document.addEventListener("DOMContentLoaded", function () {
  // Función para inicializar los productos con mega-menu-cards
  function initializeProducts() {
    const productElements = document.querySelectorAll(".products");

    productElements.forEach((product) => {
      // Verificar si ya tiene un mega-menu-cards
      const hasMegaMenuCards =
        product.querySelector(".mega-menu-cards") !== null;

      // Si tiene mega-menu-cards, añadir la clase show-sub-menu
      if (hasMegaMenuCards) {
        ///Si el producto tiene hijos (menu-nietos) entonces se adiciona la clase
        product.classList.add("show-sub-menu");
      }
    });
  }

  // Ejecutar la inicialización al cargar
  initializeProducts();

  // Función para manejar el hover en los elementos products
  function handleSubmenuHover() {
    ///Se selecionand todos los elementos con la clase products
    const productElements = document.querySelectorAll(".products");

    productElements.forEach((product) => {
      // Guardar referencias originales
      let originalParent;
      let originalNextSibling;

      // Evento mouseenter sobre el producto
      product.addEventListener("mouseenter", function () {
        //  hacer referencia <li> padre (.content-sub-menu)
        const parentMenuItem = this.closest(".content-sub-menu");
        if (!parentMenuItem) return;

        const megaMenuContainer = parentMenuItem.querySelector(
          ".mega-menu-container"
        );
        if (!megaMenuContainer) return;

        // Buscar el elemento mega-menu-cards dentro de este products
        const megaMenuCards = this.querySelector(".mega-menu-cards");

        // Guardar referencia al estado original antes de mover
        originalParent = this.parentNode;
        originalNextSibling = this.nextSibling;

        // Verificar si el elemento products contiene mega-menu-cards
        if (megaMenuCards) {
          // Si existe mega-menu-cards, clonarlo y moverlo al mega-menu-container
          const submenuClone = megaMenuCards.cloneNode(true);
          // Quitar el estilo display:none para que sea visible
          submenuClone.style.display = "grid";
          megaMenuContainer.innerHTML = "";
          megaMenuContainer.appendChild(submenuClone);

          // Agregar la clase active al mega-menu-container solo cuando hay contenido
          megaMenuContainer.classList.add("active");
          // Obtener todos los productos del <li> padre (.content-sub-menu)
          const allProducts = Array.from(
            parentMenuItem.querySelectorAll(".products")
          );
          const index = allProducts.indexOf(this);
          const row = Math.floor(index / 4); // 4 columnas por fila

          // Calcular posición de inserción (inicio de la siguiente fila)
          const insertPosition = (row + 1) * 4;
          // Insertar el mega-menu en la posición correcta
          if (insertPosition < allProducts.length) {
            allProducts[insertPosition].before(megaMenuContainer);
          } else {
            ///En caso contrario crear hijo a la clase del <li> padre (.content-sub-menu)
            parentMenuItem
              .querySelector(".content-product")
              .appendChild(megaMenuContainer);
          }
        } else {
          // Si no hay mega-menu-cards, asegurarse que el mega-menu-container esté oculto
          megaMenuContainer.innerHTML = "";
          megaMenuContainer.classList.remove("active");
        }
      });

      // Evento mouseleave para el contenedor padre
      product
        .closest(".content-sub-menu")
        ?.addEventListener("mouseleave", function () {
          //  hacer referencia <li> padre (.content-sub-menu)
          const parentMenuItem = this.closest(".content-sub-menu");
          if (!parentMenuItem) return;

          const megaMenuContainer = parentMenuItem.querySelector(
            ".mega-menu-container"
          );
          if (!megaMenuContainer) return;

          if (megaMenuContainer) {
           // Quitar la clase active
            megaMenuContainer.classList.remove("active");
          }
        });
    });
  }

  // Ejecutar la función después de un pequeño delay para asegurar que el DOM está completamente cargado
  setTimeout(handleSubmenuHover, 500);

  // Observador de mutaciones para detectar nuevos elementos products agregados dinámicamente
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          const node = mutation.addedNodes[i];
          if (node.nodeType === 1) {
            // Solo nodos de tipo elemento
            const newProducts = node.querySelectorAll(".products");
            if (
              newProducts.length > 0 ||
              node.classList?.contains("products")
            ) {
              // Volver a aplicar los event listeners a los nuevos elementos
              setTimeout(handleSubmenuHover, 100);
              break;
            }
          }
        }
      }
    });
  });

  // Configurar el observador
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

